---
ID: 66d81ee389048aba1b50e5f3
---

<script>
    import Loader from "$lib/components/elements/Loader.svelte"

    const blocks = [
  {
    "id": "ayPjLPurlr",
    "type": "text",
    "html": "<p>Deploying your EasyPageGO-generated website to Cloudflare Pages is a straightforward process. Follow the steps below to get your site live.</p><h2 id=\"prerequisites\">Prerequisites</h2><h3 id=\"download-the-website-folder\">Download the Website Folder</h3><p>Before starting, ensure you have the folder containing your website files downloaded from EasyPageGO. This folder is ready to be deployed as-is to Cloudflare Pages.</p><h3 id=\"create-the-pages-project\">Create the Pages Project</h3><ol><li><b>Log in to Cloudflare</b>: Go to the&nbsp;<u><a href=\"https://dash.cloudflare.com/\" target=\"_blank\" rel=\"noopener noreferrer\">Cloudflare dashboard</a></u>&nbsp;and log in to your account.</li><li><b>Navigate to Pages</b>: In the Cloudflare dashboard, select&nbsp;<b>Pages</b>&nbsp;from the menu on the left side.</li><li><b>Create a New Project</b>: Click the&nbsp;<b>\"Create a Project\"</b>&nbsp;button.</li></ol><h2 id=\"deploying-via-folder-upload\">Deploying via Folder Upload</h2><ol><li><b>Access Your Project</b>: In the Cloudflare Pages dashboard, select your project.</li><li><b>Deployments</b>: Click on the&nbsp;<b>\"Deployments\"</b>&nbsp;tab.</li><li><b>Drag and Drop</b>: Use the drag-and-drop area or the upload button to upload the folder you downloaded from EasyPageGO.</li><li><b>Start Deployment</b>: Cloudflare Pages will automatically start the deployment process once the folder is uploaded.</li></ol>"
  },
  {
    "type": "video",
    "id": "A1ztZuzKLH",
    "src": "https://easypagego.com/videos/deploy-md.mp4",
    "width": 600,
    "height": 400,
    "controls": true,
    "loop": false,
    "muted": true,
    "autoplay": false
  },
  {
    "id": "d_P-qtAUHZ",
    "type": "text",
    "html": "<h2 id=\"deploying-with-wrangler-cli\">Deploying with Wrangler CLI</h2><p>The Wrangler CLI is a tool provided by Cloudflare for managing and deploying Cloudflare Pages projects from the command line.</p><h3 id=\"install-and-setup-wrangler-cli\">Install and Setup Wrangler CLI</h3><p><b>Install Wrangler</b>: Open your terminal and install Wrangler using npm:</p>"
  },
  {
    "id": "VjMqosPska",
    "type": "codeblock",
    "name": "",
    "lang": "shellscript",
    "code": "npm install -g @cloudflare/wrangler",
    "height": 80
  },
  {
    "id": "L2Z843DxIT",
    "type": "text",
    "html": "<p><b>Authenticate</b>: Run the following command to authenticate Wrangler with your Cloudflare account:</p>"
  },
  {
    "id": "X5cu3H9W93",
    "type": "codeblock",
    "name": "",
    "lang": "shellscript",
    "code": "wrangler login",
    "height": 80
  },
  {
    "id": "5YwR_rIjiu",
    "type": "text",
    "html": "<h3 id=\"execute-cli-command-to-deploy\">Execute CLI Command to Deploy</h3><p><b>Navigate to Your Project Folder</b>: Open your terminal and change to the directory containing your EasyPageGO website files.</p>"
  },
  {
    "id": "-LzWVkpuWW",
    "type": "codeblock",
    "name": "",
    "lang": "shellscript",
    "code": "cd ~/Downloads/build",
    "height": 80
  },
  {
    "id": "mlPIpyRVM1",
    "type": "text",
    "html": "<p><b>Deploy Using Wrangler</b>: Use the following command to deploy your project:</p>"
  },
  {
    "id": "k7gBtwQQOI",
    "type": "codeblock",
    "name": "",
    "lang": "shellscript",
    "code": "wrangler pages publish ./ --project-name <cloudflare-pages-project-name>",
    "height": 80
  },
  {
    "id": "KPjHtHTB8V",
    "type": "text",
    "html": "<p>Replace&nbsp;<code>cloudflare-pages-project-name</code>&nbsp;with the name of your Cloudflare Pages project.</p><p><b>Monitor Deployment</b>: Wrangler will output deployment progress in the terminal. You can also check the deployment status and your live site in the Cloudflare Pages dashboard.</p>"
  }
];
</script>

{#each blocks as block}
<Loader {block}/>
{/each}